import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { Button } from "@/components/ui/button";
import { Star, ExternalLink } from "lucide-react";

export default function Reviews() {
  return (
    <section className="border-b border-border bg-background px-5 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-4xl text-center">
        <SectionHeader align="center" kicker="Reviews" title="THE PROBLEM ISN'T YOURS ANYMORE." />
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground">
          Every treatment is judged by one standard — whether the problem is actually resolved. We work to that standard on every booking, from a single bedroom to a full multi-unit property, and we ask our customers to hold us to it. Honest feedback from verified treatments is how we keep improving the way bed bugs are treated across Vancouver and the Lower Mainland.
        </p>
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col items-center gap-6">
            <div className="flex items-center gap-1">
              {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-6 w-6 fill-accent text-accent" />)}
            </div>
            <p className="max-w-xl text-base leading-relaxed text-muted-foreground">
              We display genuine customer reviews from verified treatments. If you've worked with us, we'd value your honest feedback on Google.
            </p>
            <Button asChild size="lg" className="h-12 px-8 text-sm font-semibold tracking-wide bg-primary text-white hover:bg-primary/90">
              <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer">Read Our Google Reviews <ExternalLink className="ml-1.5 h-4 w-4" /></a>
            </Button>
            <p className="text-xs text-muted-foreground/70">Reviews are sourced from verified customers. We do not publish fabricated testimonials.</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}